import * as uuid from "uuid";
import moment from "moment";
// React
import React from "react";
// Charts
import Chart from "react-google-charts";
// Components
import MissingProductInfo from "office/reports/stats/components/missingProductInfo/MissingProductInfo";
// Utils
import * as utils from "office/reports/stats/utils/utils";
import * as GraphHelper from "common/utils/GraphHelper";
import { resizeHelper } from "common/resizeHelper";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "common/ui/components/graphs/Graph.less";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export default class LargeGraph extends React.Component {
    constructor(props) {
        super(props);
        this._reportId = "";
        this._reportId = uuid.v4();
        this.state = {};
    }
    componentDidMount() {
        resizeHelper.addListener(this._reportId, (width, height) => this.onResize(width, height));
    }
    componentWillUnmount() {
        resizeHelper.removeListener(this._reportId, (width, height) => this.onResize(width, height));
    }
    onResize(width, height) {
        // Force redraw
        this.setState({});
    }
    render() {
        let { title, vAxis1Label, series, colour, fromDate, toDate } = this.props;
        // No data
        if (!utils.findSeriesWithData(series)) {
            return (React.createElement("div", { className: styles.noGraphData },
                React.createElement(MissingProductInfo, { text: "No Graph Data", isLarge: true })));
        }
        // Create graph options
        let options = {
            title: title,
            titleTextStyle: GraphHelper.defaulTitleTextStyle,
            vAxis: new GraphHelper.DefaultVAxis_Number(vAxis1Label, utils.calcVAxisGridlineCount(series)),
            hAxis: new GraphHelper.DefaultHAxis_Time(null, utils.calcDayTicks(moment(fromDate), moment(toDate))),
            legend: "none",
            animation: GraphHelper.defaultAnimation,
            lineWidth: 2,
            pointSize: 4,
            series: [{ color: colour, areaOpacity: 0.2 }] //utils.createDefaultSeriesOptions(seriesColours)
        };
        return (React.createElement("div", { className: styles.graph },
            React.createElement(Chart.Chart, { chartType: "AreaChart", graph_id: this._reportId, options: options, width: GraphHelper.defaultGraphWidth, height: GraphHelper.defaultGraphHeight, rows: series, columns: GraphHelper.getDefaultColumns(this.props.seriesLabel) })));
    }
}
